<template lang="pug">
.SignInPage
  .container
    .title キーボードリルの利用には<br>ログインが必要です
    form.form(@submit.prevent="handleFormSubmit")
      .username
        input(type="email" name="email" v-model="email" placeholder="メールアドレス")
      .password
        input(type="password" name="password" v-model="password" placeholder="パスワード")
      input.signInButton(type="submit" value="ログイン")
    .resetPasswordButton(@click="handleResetPasswordButton") パスワードを忘れた方はこちら
  .bg
</template>

<script>
import { mapState } from 'vuex'
// import admin from 'firebase-admin'
// import soundService from '@/services/SoundService'
import FirebaseService from '../services/FirebaseService'

export default {
  name: 'sign-in-page',
  components: {},
  data() {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapState('User', {
      account: state => state.account
    }),
    ...mapState('User', {
      isSignIn: state => state.isSignIn
    })
  },
  methods: {
    async signIn() {
      const userData = await FirebaseService.signIn(this.email, this.password)
      if (userData) {
        await this.$store.dispatch('User/setName', userData.name)
        await this.$store.dispatch('User/setEmail', userData.email)
        await this.$store.dispatch('User/setSignInStatus', true)
        this.$router.push('/')
      }
    },
    goToResetPassword() {
      this.$router.push('/resetPassword')
    },
    handleSignInButtonClick() {
      // this.signIn()
    },
    handleFormSubmit() {
      this.signIn()
    },
    handleResetPasswordButton() {
      this.goToResetPassword()
    }
  },
  mounted() {
    this.email = this.account.email
    FirebaseService.init('default')
    // if (this.isSignIn) {
    //   this.$router.push('/')
    // } else {
    //   console.log('not LoggedIn')
    // }
  }
}
</script>

<style lang="scss" scoped>
.SignInPage {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.container {
  padding: 20px;
  width: 300px;
  background: #fff;
  text-align: center;
  border-radius: 10px;
}

.title {
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  font-weight: bold;
}

.form input {
  margin: 0 0 10px 0;
  padding: 10px;
  width: 100%;
  font-size: 2rem;
}

.signInButton {
  @include button;
  margin: 0 0 10px 0;
  padding: 10px;
  border: 0;
  background: orange;
  text-align: center;
  border-radius: 5px;
}

.resetPasswordButton {
  @include button;
  padding: 10px;
  background: #eee;
  text-align: center;
  border-radius: 5px;
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 300vw;
  height: 300vh;
  background: url(../assets/bg_wood.jpg) repeat;
  // https://www.flickr.com/photos/seier/4342331255/sizes/l/
  animation: infinitescroll 20s linear infinite;
  z-index: -1;
}

@keyframes infinitescroll {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-1024px, -768px, 0);
  }
}
</style>
